import clsx from "clsx";
import { ReactNode } from "react";

import { FilterDropDown } from "@/features/common/components/filter/FilterDropDown";

type Option = {
  label: string | ReactNode;
  value: string | number;
};

type SingleEnumFilterProps = {
  value?: string | number;
  options: Option[];
  onSetFilter?: (value: string | number) => void;
  renderChip: (args: { value: string | number }) => ReactNode | string;
  resetFilter?: () => void;
};

export const SingleEnumFilter = ({
  value,
  options,
  onSetFilter,
  renderChip,
  resetFilter,
}: SingleEnumFilterProps) => {
  return (
    <FilterDropDown
      value={value}
      hasButton={false}
      renderChip={renderChip}
      filterOptionItem={(close) => (
        <div>
          {options?.map((option, index) => (
            <span
              key={index}
              className={clsx(
                option.value === value && !!value
                  ? "text-primary"
                  : "text-gray-500",
                "text-md flex cursor-pointer items-center justify-start space-x-1 rounded-md px-1 py-2 font-light  hover:bg-blue-50",
              )}
              onClick={() => {
                if (option.value != null || !resetFilter) {
                  onSetFilter(option.value);
                } else {
                  resetFilter();
                }

                close();
              }}
            >
              {option.label}
            </span>
          ))}
        </div>
      )}
    />
  );
};
